import React from 'react';

import { ContentZonesService } from '@sm360/widget-commons-core-services';
import { WhiteModal, MEDIA_QUERIES } from '@sm360/widget-commons-general';

import MediaQuery from 'react-responsive';

import ForgetPasswordContent from 'login/components/ForgetPassword/ForgetPasswordContent/ForgetPasswordContent.jsx';

import { FORGET_PASSWORD as MODAL } from 'login/constants/modalNames.js';

const czGroupName = 'widget.login.forms.forgotpassword';

const ForgetPasswordModal = () => {
    const modalBackgroundImageUrl =
        ContentZonesService.getContentZone(czGroupName, 'background') &&
        ContentZonesService.getContentZone(czGroupName, 'background').getValue();

    return (
        <WhiteModal
            name={MODAL}
            contentLabel="dialog with form for Sign in"
            className="widget-login-popupElement"
            isScrollable
            isClosable
            backgroundImage={modalBackgroundImageUrl}
        >
            <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                <ForgetPasswordContent className="is-scrollable" />
            </MediaQuery>
            <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                <ForgetPasswordContent />
            </MediaQuery>
        </WhiteModal>
    );
};

ForgetPasswordModal.displayName = 'ForgetPasswordModal';

export default ForgetPasswordModal;
